import React from "react";

import { ForbiddenIcon } from "../icons";
import { useAuth } from "../context/AuthContext";

function Page403() {
  const { logout } = useAuth();

  return (
    <div className="flex flex-col items-center">
      <ForbiddenIcon
        className="w-12 h-12 mt-8 text-purple-200"
        aria-hidden="true"
      />
      <h1 className="text-6xl font-semibold text-red-600 dark:text-gray-200">
        403
      </h1>
      <p className="text-gray-700 dark:text-gray-300">
        You do not have permission to access this page{" "}
        <a
          className="text-purple-600 hover:underline dark:text-purple-300"
          href="/app/dashboard"
        >
          Go to dashboard
        </a>
        .
      </p>
      <button
        className="ml-2 text-red-600 hover:underline dark:text-purple-300"
        onClick={() => {
          logout();
          window.location.href = "/login";
        }}
      >
        Log out
      </button>
    </div>
  );
}

export default Page403;
